import { useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { HiOutlineBan } from "react-icons/hi";
import EndUserMessageCard from "../components/common/EndUserMessageCard";

const LinkUnavailable = () => {
  const { t } = useTranslation("clientView");
  const [searchParams] = useSearchParams();

  const messageKey =
    searchParams.get("flow") === "password-reset"
      ? "linkUnavailable.endUserResetDescription"
      : "linkUnavailable.description";

  return (
    <>
      <Helmet>
        <title>{`Super User Manager - ${t("linkUnavailable.title")}`}</title>
        <meta
          name="description"
          content={t("linkUnavailable.description") || ""}
        />
        <meta name="robots" content="noindex" />
        <link
          rel="canonical"
          href={`${process.env.REACT_APP_HOST_URL}/link-unavailable`}
        />
      </Helmet>

      <EndUserMessageCard
        Icon={HiOutlineBan}
        iconColor="red"
        title={t("linkUnavailable.pageTitle")}
        message={t(messageKey)}
      />
    </>
  );
};

export default LinkUnavailable;
